import { InstalledModuleType } from "src/utils/constants";
import { IProduct } from "src/core/products/api/products.api";

export default (product: IProduct, installedModules: InstalledModuleType[], quantity: number, fractionDigits: 2 | 3 = 2): number => {
  // If there is no price data found in the product or if a price is not given
  // return with no price.
  if (!product || !product.prices || product.prices.length === 0) {
    return 0;
  }

  let selectedPrice = product.prices[ 0 ];

  if (installedModules.includes("price-tier")) {
    if (product.prices.length > 1) {
      for (const price of product.prices) {
        if (price.minQuantity && quantity >= price.minQuantity) {
          selectedPrice = price;
        }
      }
    }
  }

  if (selectedPrice.vatValue) {
    return parseFloat((selectedPrice.price + selectedPrice.vatValue).toFixed(fractionDigits));
  }

  return parseFloat((selectedPrice.price).toFixed(fractionDigits));
};
